export default "__VITE_ASSET__DpVbcqRN__"